import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface UnsavedChangesDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  message?: string;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onConfirm,
  onCancel,
  message = "You have unsaved changes. Are you sure you want to leave?"
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="unsaved-changes-dialog-title"
      aria-describedby="unsaved-changes-dialog-description"
    >
      <DialogTitle id="unsaved-changes-dialog-title">
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="warning" />
          Unsaved Changes
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">
          {message}
        </DialogContentText>
        <DialogContentText sx={{ mt: 2, fontSize: '0.9rem', color: 'text.secondary' }}>
          Your changes will be lost if you leave this page.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Stay on Page
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Leave Without Saving
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
